/**
 * Antetul grilei zilei.
 *
 * Sta separat de `PlanPlatiZi` pentru un motiv concret: aici a fost un bug pe care nu-l putea
 * prinde niciun test de logica. Celula de antet a checkbox-ului era
 * `<span className="celula doar-sr">`, iar `.doar-sr` e `position: absolute`. **Un copil absolut
 * pozitionat al unui container grid iese din plasarea automata** — deci acea celula nu ocupa nicio
 * coloana, si toate antetele de dupa alunecau exact o coloana la stanga: „Sumă" ajungea deasupra
 * coloanei Furnizor, „Bancă" deasupra Facturilor.
 *
 * Regula, valabila pentru orice coloana adaugata de aici inainte: **antetul are exact atatia copii
 * directi cate coloane are grila**, iar textul ascuns se pune intr-un `<span>` INTERIOR, niciodata
 * pe elementul de grid.
 *
 * A doua regula, tot din acelasi bug: alinierea antetului foloseste ACEEASI clasa ca celula de sub
 * el — de aceea vine din `DefinitieColoana.aliniere`, una singura pentru amandoua. Un `text-right`
 * pe un container flex n-ar muta nimic, iar antetul ar parea aliniat in cod si nu ar fi pe ecran.
 */

import type { CheieSortare, DefinitieColoana } from './coloane.ts';

export interface PropsAntetGrila {
  /** Valoarea pentru `grid-template-columns`; vine din `sablonColoane`. */
  sablon: string;
  coloane: readonly DefinitieColoana[];
  sort: CheieSortare | undefined;
  onSort: (cheie: CheieSortare) => void;
}

export function AntetGrila({ sablon, coloane, sort, onSort }: PropsAntetGrila) {
  return (
    <div
      role="row"
      aria-rowindex={1}
      data-antet-grila
      className="grila-cap grid items-center"
      style={{ gridTemplateColumns: sablon }}
    >
      {coloane.map((col) => {
        const continut = col.ascunsa ? (
          <span className="doar-sr">{col.eticheta}</span>
        ) : col.sortare === undefined ? (
          col.eticheta
        ) : (
          <button
            type="button"
            className="hit-24"
            tabIndex={-1}
            onClick={() => onSort(col.sortare as CheieSortare)}
          >
            {col.eticheta}
            {sort === col.sortare ? <span aria-hidden="true"> ↓</span> : null}
          </button>
        );

        return (
          <span
            key={col.cheie}
            role="columnheader"
            className={`celula ${col.aliniere ?? ''}`}
            title={col.descriere}
            {...(col.sortare === undefined
              ? {}
              : { 'aria-sort': sort === col.sortare ? ('ascending' as const) : ('none' as const) })}
          >
            {continut}
          </span>
        );
      })}
    </div>
  );
}
